import React from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { DateFormats } from '../../../_lib/components/DateFormat';
import { StatisticTypes } from '../PageStatistics.types';
import { Strong } from '../../../components/atoms/Strong/Strong';
import { TableCellModifier } from '../../../components/organisms/Table/TableCell';

export function usePageStatistics(type: StatisticTypes) {
  const { t } = useSonTranslation('PageStatistics');

  const dateTrans: string = t(`statistics.${type}`);
  const total: string = t('statistics.total');
  const individual: string = t('statistics.individual');
  const totalSubtree: string = t('statistics.totalsubtree');
  const individualSubtree: string = t('statistics.individualsubtree');

  const getDateFormatByType = (): DateFormats => {
    switch (type) {
      case 'yearly':
        return DateFormats.YEAR;
      case 'monthly':
        return DateFormats.MONTH_AND_YEAR;
      case 'daily':
      default:
        return DateFormats.DATE_WITH_SHORT_NAME_OF_THE_WEEK;
    }
  };
  // checking for breakpoint change
  const cellModifier = [TableCellModifier.ALIGN_RIGHT, TableCellModifier.LOWPADDING];
  const cellModifierLarge = [...cellModifier, TableCellModifier.WIDTH_23_100];

  function getCaption() {
    switch (type) {
      case 'daily':
        return <Strong>{t(`lastPageVisits.daily`)}</Strong>;
      default:
        return (
          <>
            <Strong>{t(`lastPageVisits.${type}`)}</Strong>
            {` ${t('lastPageVisits.withoutToday')}`}
          </>
        );
    }
  }

  return {
    dateTrans,
    total,
    individual,
    totalSubtree,
    individualSubtree,
    cellModifier,
    cellModifierLarge,
    getCaption,
    getDateFormatByType,
  };
}
